"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCovid19RecordDto = instanceOfCovid19RecordDto;
exports.Covid19RecordDtoFromJSON = Covid19RecordDtoFromJSON;
exports.Covid19RecordDtoFromJSONTyped = Covid19RecordDtoFromJSONTyped;
exports.Covid19RecordDtoToJSON = Covid19RecordDtoToJSON;
exports.Covid19RecordDtoToJSONTyped = Covid19RecordDtoToJSONTyped;
const Covid19BoosterDto_1 = require("./Covid19BoosterDto");
const Covid19DoseDto_1 = require("./Covid19DoseDto");
/**
 * Check if a given object implements the Covid19RecordDto interface.
 */
function instanceOfCovid19RecordDto(value) {
    return true;
}
function Covid19RecordDtoFromJSON(json) {
    return Covid19RecordDtoFromJSONTyped(json, false);
}
function Covid19RecordDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'primarySeries': json['primarySeries'] == null ? undefined : (json['primarySeries'].map(Covid19DoseDto_1.Covid19DoseDtoFromJSON)),
        'boosters': json['boosters'] == null ? undefined : (json['boosters'].map(Covid19BoosterDto_1.Covid19BoosterDtoFromJSON)),
    };
}
function Covid19RecordDtoToJSON(json) {
    return Covid19RecordDtoToJSONTyped(json, false);
}
function Covid19RecordDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'primarySeries': value['primarySeries'] == null ? undefined : (value['primarySeries'].map(Covid19DoseDto_1.Covid19DoseDtoToJSON)),
        'boosters': value['boosters'] == null ? undefined : (value['boosters'].map(Covid19BoosterDto_1.Covid19BoosterDtoToJSON)),
    };
}
//# sourceMappingURL=Covid19RecordDto.js.map